import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { usePermissions } from '../../hooks/usePermissions'
import { LoadingSpinner } from '../ui/loading-states'

interface RequireSectionRouteProps {
  section: string
  level?: 'view' | 'edit'
  children: ReactNode
}

/**
 * Гейтинг маршрута по правам роли. Если раздел недоступен — редирект на дашборд.
 * Бэкенд всё равно проверяет доступ; это UX-защита от прямого перехода по URL.
 */
export function RequireSectionRoute({
  section,
  level = 'view',
  children,
}: RequireSectionRouteProps) {
  const { can, isLoading } = usePermissions()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-20">
        <LoadingSpinner />
      </div>
    )
  }

  if (!can(section, level)) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
